<template>
  <header class="header" :class="{'sticky': showMobileMenu}" role="banner">
    <div class="header_container">
      <button class="header__menu" @click="toggleMenu()" :aria-expanded="showMobileMenu.toString()">
        <svg class="logo-menu">
          <title>{{ $t('global_mobile_menu_alt') }}</title>
          <use xlink:href="@/assets/symbols.svg#menu"></use>
        </svg>
      </button>
      <router-link class="header__logo" :to="{ name: 'home', params: { lang: $i18n.locale }}">
        <c-logo></c-logo>
        <span class="header__subtitle">
          {{ $t('homepage_title') }}
        </span>
      </router-link>
      <nav class="header__nav-desktop">
        <ul>
          <li class="header__item">
            <router-link :title="$t('header_menu_offers_alt')" :to="{ name: 'job-offers', params: { lang: $i18n.locale }}">
              {{ $t('header_menu_offers') }}
            </router-link>
          </li>
          <li class="header__item">
            <a :title="$t('global_menu_contact_alt')" :href="$t('global_menu_contact_link')">
              {{ $t('global_menu_contact') }}
            </a>
          </li>
          <li class="header__item header__item--lang">
            <select v-model="$i18n.locale" :aria-label="$t('global_language_selector_alt')">
              <option value="en">{{ $t('header_language_en') }}</option>
              <option value="fr">{{ $t('header_language_fr') }}</option>
            </select>
          </li>
        </ul>
      </nav>
    </div>
    <transition name="slideleft-fade">
      <div class="header__mobile" v-if="showMobileMenu">
        <nav class="header__nav-mobile" @click="showMobileMenu = false">
          <ul>
            <li class="header__item-mobile">
              <router-link :title="$t('header_menu_offers_alt')" :to="{ name: 'job-offers', params: { lang: $i18n.locale }}">
                {{ $t('header_menu_offers') }}
              </router-link>
            </li>
            <li class="header__item-mobile">
              <a :title="$t('global_menu_contact_alt')" :href="$t('global_menu_contact_link')">
                {{ $t('global_menu_contact') }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
import Logo from '@/components/VLogo.vue'

export default {
  name: 'C-Header',
  data () {
    return {
      showMobileMenu: false
    }
  },
  components: {
    'c-logo': Logo
  },
  methods: {
    toggleMenu () {
      this.showMobileMenu = !this.showMobileMenu
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.header {
  position: relative;
  &.sticky{
    position: sticky;
    top: 0;
  }
  background: white;
  z-index: 100;
  border-bottom: 1px solid #f0f0f0;
  @media screen and (min-width: $mq-medium) {
    background: white;
  }
  .header_container{
    display: flex;
    padding-right: 11px;
    padding-left: 11px;
    margin-right: 11px;
    margin-left: 11px;
    border-right: 1px solid #f0f0f0;
    border-left: 1px solid #f0f0f0;
    min-height: 5.1rem;
    align-items: center;
    @media screen and (min-width: $mq-medium) {
      min-height: 5.6rem;
    }
  }
  nav {
    ul {
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
    }
  }
  &__mobile {
    position: fixed;
    z-index: 10;
    top: 5.2rem;
    bottom: 0;
    right: 0;
    left: 0;
    background: #f2f2f2;
  }
  &__container {
    display: flex;
    position: absolute;
    .close {
      position: absolute;
      top: 5px;
      left: 5px;
      svg {
        fill: white;
      }
    }
  }
  &__menu {
    appearance: none;
    background: none;
    border: none;
    display: block;
    position: absolute;
    left: 2rem;
    margin: 0;
    padding: 16px 13px;
    padding-right: 20px;
    border-right: 1px solid #f0f0f0;
    cursor: pointer;
    color: #4d4d4d;
    @media screen and (min-width: $mq-medium) {
      display: none;
    }
    svg {
      display: block;
      width: 18px;
      height: 16px;
    }
  }
  &__logo {
    display: inline-flex;
    align-items: center;
    margin: auto;
    text-decoration: none;
    margin-left: 65px;
    @media screen and (min-width: $mq-medium) {
      margin: 0 auto 0 0;
      margin-left: 14px;
    }
  }
  &__subtitle {
    display: none;
    font-family: $ff-gotham-300;
    color: $c-text-paragraph;
    text-transform: uppercase;
    font-size: 1.6rem;
    margin-left: 1.5rem;
    @media screen and (min-width: $mq-medium) {
      display: block;
    }
  }
  &__item {
    display: none;
    margin-right: 2rem;
    margin-bottom: 3px;
    &:last-child {
      margin-right: 0;
    }
    @media screen and (min-width: $mq-medium) {
      display: inline-block;
    }
    select {
      @include select-css();
      cursor: pointer;
      border: 0;
      margin: 0;
      padding-left: 0;
      margin-bottom: -2px;
    }
    select,
    a {
      text-decoration: none;
      text-transform: uppercase;
      font-family: $ff-gotham-700;
      color: $c-text-black;
      font-size: 1rem;
      letter-spacing: 2px;
      transition: color 0.4s $easing;
      position: relative;
      &:before{
        position: absolute;
        bottom: -3px;
        left: 0;
        display: block;
        width: 0;
        height: 1px;
        content: "";
        background-color: black;
      }
      &:hover {
        color: $c-text-black;
        &:before{
          transition: width .5s;
          width: 100%;
        }
      }
    }
    &--lang {
      display: inline-block;
    }
  }
  &__nav-mobile {
    right: 0;
    padding:0 2.5rem;
    width: 100%;
    height: 100%;
    ul{
      flex-direction: column;
      height: 100%;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }
  }
  &__item-mobile {
    display: block;
    width: 100%;
    padding: 0 0 2rem;
    a {
      color: black;
      text-decoration: none;
      font-family: $ff-galaxieitalic-400;
      margin-bottom: 20px;
      font-size: 3.2rem;
    }
  }
}
</style>
